import '@patsnap-ui/icon/assets/solid/stop.svg'
import { defineComponent } from '@vue/composition-api'
import { GIcon } from '../../../ui/GIcon/GIcon'
import { GTooltip } from '../../../ui/GTooltip/GTooltip'
import cn from './locales/cn.json'
import en from './locales/en.json'
import jp from './locales/jp.json'

export const BOrganizationClosedStatus = defineComponent({
  name: 'BOrganizationClosedStatus',
  i18n: {
    messages: {
      cn,
      en,
      jp,
    },
  },
  props: {
    /**
     * 是否是tag样式
     */
    isTag: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否显示文本
     */
    showText: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否显示tooltip
     */
    showTooltip: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return {}
  },
  methods: {
    renderClosedStatus() {
      return (
        <span
          class={{
            'inline-flex items-center': true,
            'px-1': this.showText,
            'rounded bg-[#FBEDEF] p-[1px]': this.isTag,
          }}
        >
          <GIcon svgName="SolidStop" color="#D11A32" size={18} />
          {this.showText ? <span class="text-xs text-red-default leading-4">{this.$t('organizationCard.closedStatus')}</span> : null}
        </span>
      )
    },
  },
  render() {
    return (
      <GTooltip disabled={!this.showTooltip} theme="light" mode="text" content={this.$tc('organizationCard.closedStatus')} placement="top">
        {this.renderClosedStatus()}
      </GTooltip>
    )
  },
})
